import moment from 'moment';
import 'moment-timezone';
import { HANDLE_CLICK } from '../search/actions/_types';
import fixTimeZone from '../../../common/timeZone';

const getTime = (sortedSessions) => {
  let sessionTime;
  if (sortedSessions.length > 0 && sortedSessions.length < 2) {
    const {
      start: sessionStart,
      end: sessionEnd,
      meetingLocation,
      location: activityLocation,
    } = sortedSessions[0];
    const timezone = meetingLocation ? meetingLocation.timezone : activityLocation.timezone;
    const start = moment(sessionStart).tz(timezone);
    const end = moment(sessionEnd).tz(timezone);
    const startDate = `${start.format('MMM')} ${start.format('D')}`;
    const endDate = `${end.format('MMM')} ${end.format('D')}`;
    const endTime = end.format('h:mma');
    const locationTimezoneId = moment.tz(activityLocation.timezone).format('z');
    locationTimezoneId.toString();
    // Update start time display if start and end am/pm are the same
    let startTime;
    if (start.format('a') !== end.format('a')) {
      startTime = start.format('h:mma');
    } else {
      startTime = start.format('h:mm');
    }
    if (startDate !== endDate) {
      // Set time display to show start to end if session spans multi days
      startTime = start.format('h:mma');
      sessionTime = `${startDate}, ${startTime}-${endDate}, ${endTime}`;
    } else {
      // Set time display to show time span for a single day
      sessionTime =
        startTime !== endTime
          ? `${startDate}, ${startTime}-${endTime}`
          : `${startDate}, ${startTime}`;
    }
    const timeZoneId = start.format('z');
    const tz = fixTimeZone(timeZoneId);
    sessionTime = `${sessionTime} ${tz}`;
  }
  return sessionTime;
};

const getPrice = (sortedSessions) => {
  const allPrices = sortedSessions.map(({ memberPrice, nonMemberPrice }) =>
    memberPrice < nonMemberPrice ? memberPrice : nonMemberPrice,
  );
  const minPrice = allPrices.reduce((price1, price2) => Math.min(price1, price2));
  if (minPrice === 0) {
    return 'Free';
  }
  if (minPrice > 0) {
    return `from $${minPrice}`;
  }
  return '';
};

const getAvailableSpots = (sortedSessions) => {
  const availableSpots = sortedSessions.map(({ spots: { available } }) => available);
  const sum = availableSpots.reduce((spot1, spot2) => spot1 + spot2);
  return sum;
};

export default (state, getters, rootState) =>
  ({ [HANDLE_CLICK]: handleClick }) => {
    const {
      search: { searchResults },
      locationParams,
    } = state;
    const { search } = rootState;

    return searchResults.map((r) => {
      const {
        courseId,
        courseUri,
        baseImageUri,
        name,
        courseTypeLabel: courseType,
        durationLabel: duration,
        data,
        waitList,
        isSoldOut,
      } = r;
      const { sortedSessions = [] } = data || {};

      const nextQuery = new URLSearchParams(search);
      const locationQuery = new URLSearchParams(locationParams);

      // Merge both search params
      locationQuery.forEach((value, key) => {
        nextQuery.set(key, value);
      });

      const allParams = Array.from(nextQuery.values());
      const prefixParams = allParams && allParams.length ? '?' : '';
      const browserLink = `${courseUri}${prefixParams}${nextQuery.toString()}`;
      const disabled = isSoldOut;
      let badge;
      if (waitList) {
        badge = {
          type: 'warning',
          text: 'Join waitlist',
        };
      } else if (isSoldOut) {
        badge = {
          type: 'sold-out',
          text: 'Sold out',
        };
      }

      return {
        key: courseId,
        baseImageUri,
        badge,
        disabled,
        availableSpots: getAvailableSpots(sortedSessions),
        result: {
          courseId,
          name,
          courseType,
          duration,
          time: getTime(sortedSessions),
          price: getPrice(sortedSessions),
          link: {
            attrs: {
              href: courseUri,
            },
            on: {
              click: (event) =>
                handleClick({
                  external: true,
                  event,
                  to: browserLink,
                  analytics: {
                    section: 'results',
                    linkText: name,
                  },
                }),
            },
          },
        },
      };
    });
  };
